module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "chapter08"
    }
  }), _vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("With the resources Charlie had once had at his disposal, it would not have taken more than a few hours to identify the people in the photograph. By himself it took almost two days. But then he had had to create a diversion, expecting Pendlebury to check up on the photographs he had obtained. For most of the first day he had sought the names of people on the other freeze frames, coming to those he wanted last.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The husband and wife team were first. The Waldorf social director recognised the man as a junior Canadian minister attached to the United Nations, which explained Cosgrove’s greeting. The Waldorf man gave a lead to the masculine woman, too, and by the afternoon Charlie had her named as a fashion designer as interested in taking clothes off women as in putting them on. Charlie idly wondered in which capacity Sally Cosgrove knew her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sun-tanned man remained a problem, apparently known by no one. Charlie tried the "), _c('i', [_vm._v("New York Times")]), _vm._v(" photographic library, but was told it was not open to the public and then, in increasing desperation, looked up the philatelic magazines in the Yellow Pages and touted the picture—cut away now from the people who had stood momentarily at the door of the exhibition hall—around every office listed. A photographer at the last one thought he knew the man, but couldn’t identify him by name. He believed him to be an industrialist, however.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With that slender lead, Charlie went to the "), _c('i', [_vm._v("Wall Street Journal")]), _vm._v(" and by noon of the second day knew the picture to be that of a millionaire named Giuseppe Terrilli.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alone in his hotel room, Charlie spread the pictures and information he had been able to gather across his bed and stared down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Waste of time,’ he told himself, having gone from each picture to his fact sheet, repeating the process several times. A diplomat free-loading off champagne and caviar, a lesbian choosing the best social event of the night, and a rich man interested in stamps attending an unusual philatelic exhibition. Yet there "), _c('i', [_vm._v("had")]), _vm._v(" to be something. Charlie’s instinct told him so, and he placed great reliance upon instinct. It had been nothing more than instinct, eight years before, that had initially made him suspect that he was being set up as a disposable sacrifice by the American and British Intelligence Services. Later he’d stood in a darkened East Berlin doorway and seen the car that he should have been driving engulfed in flames and rifle fire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He felt that instinct awakening now. Something about the four people at whose pictures he was gazing had brought a reaction from Pendlebury, and a peculiar one too. Until their entry, the man hadn’t drunk. As soon as they had come into the room, he’d taken a glass from a passing tray and hadn’t stopped from then on. Until their arrival, he hadn’t looked away from the door. Once they had passed through it, he had hardly looked in that direction again. He had relaxed, in fact. Entrusted with the safety of stamps worth £3,000,000, why would a man relax when display cases were opening and closing like a cuckoo’s mouth and the room was jammed with people, creating the best conditions for a robbery?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And the relaxation had continued. Pendlebury hadn’t neglected the job; he was far too professional for that. But there had been a sureness about him, as if he were confident the exhibition was safe. Yet at their first meeting, he had said a theft was always possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘"), _c('i', [_vm._v("If it’s too quiet, make a noise.")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another dictum from Sir Archibald. But not as easily put into practice as it had once been. What could he do to put Pendlebury to the test and see if, for once, his instinct had failed?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Slowly he put the photograph into his briefcase, sighing as the answer came to him. Could she do it, without cocking it up? There would always be the risk, but he needed a third party and she was the only one available.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He picked up the telephone, dialling her suite number hopefully. He was at the point of replacing the receiver when Clarissa answered, thick with sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You all right?’ he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She recognised his voice. ‘Perfect,’ she said. ‘Except that I always wake up with these strange urges.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s five o’clock in the afternoon.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Afternoons are dreary. It’s nights that are fun.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I want to talk to you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Come up for breakfast.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlie hesitated; at least whores got paid for it, even the male ones.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t like orange juice,’ he said. ‘Make it apple.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the time he got to her suite, Clarissa had combed her hair but she hadn’t bothered about make-up. Despite the life she had led, her face remained remarkably unlined. Charlie wondered if she had undergone much cosmetic surgery; certainly no one outside a comic or a beauty surgery had breasts like that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ve just spoken to Rupert,’ she said. ‘I told him we were going to have breakfast together and he sends his love.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh,’ said Charlie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He also asked if you were enjoying yourself and I said I didn’t think so, not very much.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Pendlebury told me you’d said you were going to Florida,’ said Charlie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I thought I might. I’ve friends on an island. Sally is going down.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Will you go straight there?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She grinned. ‘You have a better idea?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a noise at the door leading into the sitting room and Charlie admitted the waiter. She’d ordered champagne, he saw, shaking his head at the artificiality of it all. He tipped the man and when he turned, saw that she had got out of bed. Her nightdress was completely diaphanous and she didn’t bother with a wrap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Embarrassed?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No,’ he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Shall I tell you a secret?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m an exhibitionist.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I would never have thought so,’ said Charlie. He uncorked the wine and poured it for her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Aren’t you having any?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sipped his apple juice, watching her; she would have regaled her friends with what they had done together, Charlie guessed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Could you come to Palm Beach briefly?’ he asked")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Of course.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Would you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Are you propositioning me?’ She was smiling, holding her wineglass between her hands and staring at him over the top. It was a very staged pose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I want you to do something for me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You make it sound very mysterious.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It might be important. To Rupert, as well as me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She moved the ice bucket so that he would have an uninterrupted view of her body.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Do you think I’m spoilt?’ she demanded unexpectedly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlie hesitated, wondering what reply she wanted and not wanting to annoy her until she’d done what he wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Utterly,’ he said at last.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Do I irritate you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Quite a lot.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She pulled a face, but Charlie knew he’d got it right. She wasn’t offended.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yet you come to me for help.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There isn’t anyone else,’ said Charlie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She laughed in genuine amusement. ‘Christ, you’re odd,’ she said. ‘You really fascinate me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She put her champagne glass down, pouring coffee instead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I went a bit over the top with that, didn’t I?’ she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Just a bit,’ agreed Charlie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now I’ve got indigestion.’ She belched, very slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s the bubbles,’ said Charlie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman crumpled a croissant into crumbs without bothering to eat any of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m supposed to be going out tonight,’ she said. ‘Same crowd, same places.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlie was curious at the boredom she injected into her voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She stared at him. ‘You know what I’d really like to do instead?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Go back to bed. With you. And spend the rest of the day there watching television when we feel like it and not watching it when we don’t.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had expected to pay a price, remembered Charlie. And his feet "), _c('i', [_vm._v("were")]), _vm._v(" painful after all the walking he’d done to identify the people in the photographs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Will you come to Palm Beach?’ he demanded, wanting the bargain agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes,’ she promised.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Do you want to call them, to say you won’t be coming?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shook her head. ‘They won’t really miss me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not even Sally Cosgrove?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She’ll manage. She doesn’t like you very much.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I know.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Says you weren’t very respectful to her husband.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He wasn’t very respectful to me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’re an inverted snob,’ she accused.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes,’ agreed Charlie, readily. ‘I probably am.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It had been an occasional complaint from Edith, remembered Charlie. Particularly after Sir Archibald had been removed and the new regime had taken over, demoting him from his special position within the Department. He suspected she had regarded it as the jealousy of a grammar school boy for university graduates, but it really hadn’t been. They had been bloody fools, all of them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I told her she was wrong,’ said Clarissa.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Thanks a lot,’ said Charlie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t be flip,’ she said. ‘I don’t want either of us to be flip.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Was it a performance to fit the circumstances, wondered Charlie, or genuine?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t like being a cow to Rupert,’ she said, suddenly. ‘I really don’t.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why are you then?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shrugged. ‘I don’t seem able to help it. It’s despicable, I know. But I really can’t help it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’d known another woman just like Clarissa. She’d been secretary to the ex-army general who had replaced Sir Archibald. Like Clarissa, she had screwed him for the novelty, and he had screwed her to find out what was going on behind his back. Then, like now, it had seemed a perfect equation. He hoped it worked as well with Clarissa as it had with the other girl.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We could be missing a good programme,’ she said, rising. She was already in bed, the television page of the "), _c('i', [_vm._v("Daily News")]), _vm._v(" in her hands, when he entered the adjoining room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She cradled into his arms the moment he got into bed. He sat against the bedhead, supporting her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Tell me what you want me to do in Palm Beach.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Later,’ said Charlie. He wondered how Pendlebury would react when Clarissa let drop that Charlie expected a robbery in Florida. If he were wrong about the American and Pendlebury panicked to the local police, he would look a complete idiot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He took the newspaper from the woman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A Western, a quiz programme or a Clark Gable nostalgia film?’ he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Clark Gable nostalgia,’ she said immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That doesn’t start for another hour.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I know.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m not convinced that we’re doing the right thing about this damned insurance man,’ said Warburger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Neither am I,’ added Bowler loyally.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He’s not done anything we can’t handle so far,’ said Pendlebury defensively.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He’s got a freeze frame of Terrilli,’ Warburger reminded him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And four other sets of photographs of different people,’ said Pendlebury. ‘The Terrilli photograph is no more important to him at the moment than those twelve other people.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘So why did he have them made?’ demanded the Director. ‘Why Terrilli? Why any of them?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Because he’s good, like I said,’ insisted Pendlebury. He was aware of the looks which passed between the Director and his deputy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’re not seeing this as some sort of personal challenge, are you?’ demanded the Director.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I would have hoped you would have known me better than that,’ said Pendlebury.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’ve had a watch kept on him?’ Bowler asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Constantly,’ said Pendlebury.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What’s he done?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Gone around trying to get the pictures identified.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Nothing else?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Screwed the boss’s wife.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘So do half the men in America,’ said Warburger. ‘It’s the other thing I’m worried about.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Trust me,’ pleaded Pendlebury. ‘I know it’s going to turn out all right.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘For a little longer,’ conceded Warburger. ‘But I still might pull the rug from under him, despite what you say.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bowler was escorting Pendlebury from the building when he suddenly stopped, reminded of something.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Practice,’ he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What?’ asked Pendlebury.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There was a memo on my desk yesterday. Apparently you’re overdue for pistol practice.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Surely you don’t expect me to break away from what I’m doing just to keep within the rules?’ said Pendlebury, whose ears always ached from the explosions, even though he wore ear mufflers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I suppose not,’ admitted Bowler, to whom regulations were important.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You could grant me exemption,’ prompted Pendlebury.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Just this once,’ agreed Bowler, ‘but there’s no way you can be excused again. It’s clearly stated.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I know,’ said Pendlebury, relieved. ‘I know.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Another thing,’ continued Bowler. ‘Your expenses are very high.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s a very important job,’ said Pendlebury. ‘And there are a lot of receipts.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t get greedy,’ warned the Deputy Director.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63ec33e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/xhtml/chapter08.vue
// module id = 108
// module chunks = 0